import React, {useState} from "react";
import {Button, Form, message, Modal, Select} from "antd";
import {DownloadOutlined} from "@ant-design/icons";
import {useStore} from "hooks/useStore";
import {useFetch} from "hooks/useFetch";
import {useFormik} from "formik";
import * as Yup from "yup";
import {b64DecodeToUrl} from "utils/helpers";

export const ContractPreviewGenerator = ({courierId, showOnlyCourierContractTypes = false}) => {
    const [visible, setVisible] = useState(false);

    const stores = useStore();

    const [contractTypesDataLoading, contractTypesData] = useFetch({
        fetchFn: stores.contractStore.getContractTypes.bind(null, {}),
        dependencies: [visible, courierId],
        condition: visible && courierId,
        initialCall: true
    });

    const formik = useFormik({
        initialValues: {
            courierId: courierId,
            contractName: undefined
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            contractName: Yup.string().required("Sözleşme tipi seçilmedi")
        }),
        onSubmit: async values => {
            try {
                const response = await stores.contractStore.generateContractPreview(values);
                const contract = response?.contract;
                const base64Data = contract?.base64File;
                const blobUrl = await b64DecodeToUrl(base64Data);
                const link = document.createElement("a");
                link.href = blobUrl;
                link.setAttribute("download", `${contract?.name}`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                formik.resetForm();
                setVisible(false);
                message.success("Sözleşme oluşturuldu/indirildi");
            } catch (error) {
                message.error("Sözleşme oluşturulamadı/indirilemedi");
            }
        }
    });
    return (
        <>
            <Button icon={<DownloadOutlined />} onClick={() => setVisible(true)}>
                Sözleşme Oluştur
            </Button>

            <Form onSubmit={formik.handleSubmit}>
                <Modal
                    visible={visible}
                    onCancel={() => setVisible(false)}
                    title="Sözleşme Oluştur"
                    footer={[
                        <Button
                            key="cancel"
                            onClick={() => setVisible(false)}
                            disabled={formik.isSubmitting}
                        >
                            İptal
                        </Button>,
                        <Button
                            key="submit"
                            type="primary"
                            htmlType="submit"
                            onClick={formik.handleSubmit}
                            loading={formik.isSubmitting}
                            disabled={formik.isSubmitting}
                        >
                            Sözleşme Oluştur/İndir
                        </Button>
                    ]}
                >
                    <Form.Item
                        label="Sözleşme Tipi"
                        name="contractName"
                        validateStatus={
                            formik.touched.contractName && formik.errors.contractName ? "error" : ""
                        }
                        help={formik.touched.contractName && formik.errors.contractName}
                    >
                        <Select
                            placeholder="Sözleşme tipi seçin"
                            onChange={value => formik.setFieldValue("contractName", value)}
                            value={formik.values.contractName}
                            disabled={contractTypesDataLoading || formik.isSubmitting}
                            loading={contractTypesDataLoading || formik.isSubmitting}
                        >
                            {contractTypesData &&
                                Object.values(contractTypesData.types || {})
                                    .filter(contractType => {
                                        // Şimdilik, sadece ekipman sözleşmesine izin veriyoruz.
                                        return [
                                            "courierEquipmentAgreement",
                                            "courierEmployerTerminationAgreement",
                                            "courierPersonalTerminationAgreement"
                                        ].includes(contractType);

                                        if (!showOnlyCourierContractTypes) return true;

                                        return Object.values(
                                            contractTypesData?.courierTypes
                                        ).includes(contractType);
                                    })
                                    .map(contractType => (
                                        <Select.Option key={contractType} value={contractType}>
                                            {contractTypesData.displayNames?.["tr"]?.[contractType]}
                                        </Select.Option>
                                    ))}
                        </Select>
                    </Form.Item>
                </Modal>
            </Form>
        </>
    );
};
